var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import Icon from '@datashop/icon';
import Loader from '@datashop/loader';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps, css = styledComponents.css;
var getRightPlaceholderStyle = function (textColor, fontWeight) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: right;\n  padding-right: 8px;\n  color: ", ";\n  font-weight: ", ";\n"], ["\n  text-align: right;\n  padding-right: 8px;\n  color: ", ";\n  font-weight: ", ";\n"])), textColor, fontWeight); };
var Wrapper = withProps(styled.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  position: relative;\n\n  ", "\n\n  \n"], ["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  position: relative;\n\n  ",
    "\n\n  \n"])), function (_a) {
    var disabled = _a.disabled;
    return "\n      pointer-events:" + (disabled ? 'none' : 'auto') + "\n      opacity:" + (disabled ? '0.3' : '1') + "\n    ";
});
var getIconColor = function (theme, empty, error) {
    if (error) {
        return theme.datashop.palette.red.main;
    }
    if (empty) {
        return theme.datashop.palette.night.lightest;
    }
    return theme.datashop.palette.night.main;
};
var IconLeft = withProps(styled(Icon))(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  vertical-align: middle;\n  font-size: 16px;\n  color: ", ";\n"], ["\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  vertical-align: middle;\n  font-size: 16px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, error = _a.error, empty = _a.empty;
    return getIconColor(theme, empty, error);
});
var InputWrapper = withProps(styled.input)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: 3px;\n  height: 32px;\n  line-height: 1.4;\n  font-size: 15px;\n  box-sizing: border-box;\n  &::-ms-clear {\n    display: none;\n  };\n  color: ", ";\n  padding: 7px ", " 7px ", ";\n  border: solid 1px ", ";\n\n  &::placeholder{\n    ", "\n  }\n  \n  &:focus{\n    outline: 0;\n\n    ", "\n  }\n\n  &:focus + ", "{\n    color: ", ";\n  }\n"], ["\n  border-radius: 3px;\n  height: 32px;\n  line-height: 1.4;\n  font-size: 15px;\n  box-sizing: border-box;\n  &::-ms-clear {\n    display: none;\n  };\n  color: ", ";\n  padding: 7px ",
    " 7px ",
    ";\n  border: solid 1px ",
    ";\n\n  &::placeholder{\n    ",
    "\n  }\n  \n  &:focus{\n    outline: 0;\n\n    ",
    "\n  }\n\n  &:focus + ", "{\n    color: ",
    ";\n  }\n"])), function (props) { return props.theme.datashop.palette.neutral.main; }, function (_a) {
    var clearButton = _a.clearButton, loading = _a.loading;
    return clearButton || loading ? '32px' : '0';
}, function (props) {
    return props.icon ? '32px' : '12px';
}, function (props) {
    return props.error
        ? props.theme.datashop.palette.red.main
        : props.theme.datashop.palette.stone.main;
}, function (props) {
    return "\n        color : " + props.theme.datashop.palette.night.lightest + ";\n        font-family: inherit;\n        " + (props.placeholderPosition === 'right'
        ? getRightPlaceholderStyle(props.theme.datashop.palette.stone.dark, props.theme.datashop.weights.semibold)
        : '') + "}\n      ";
}, function (props) { return "\n      border: solid 1px " + (props.error
    ? props.theme.datashop.palette.red.main
    : props.theme.datashop.palette.blue.main) + ";\n      box-shadow: " + (props.error
    ? '0 0 0 3px rgba(217, 55, 55, 0.16)'
    : '0 0 0 3px rgba(2, 112, 221, 0.16)') + ";\n    "; }, IconLeft, function (props) {
    return props.error
        ? props.theme.datashop.palette.red.main
        : props.theme.datashop.palette.blue.main;
});
var ClearButton = styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  cursor: pointer;\n"])));
var InputLoader = styled(Loader)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n"], ["\n  position: absolute;\n  right: 8px;\n"])));
export var Input = function (_a) {
    var disabled = _a.disabled, iconCustomClass = _a.iconCustomClass, icon = _a.icon, error = _a.error, loading = _a.loading, clearButton = _a.clearButton, onClearClick = _a.onClearClick, wrapperStyle = _a.wrapperStyle, props = __rest(_a, ["disabled", "iconCustomClass", "icon", "error", "loading", "clearButton", "onClearClick", "wrapperStyle"]);
    return (React.createElement(Wrapper, { disabled: disabled, style: wrapperStyle },
        React.createElement(InputWrapper, __assign({ clearButton: clearButton, loading: loading, error: error, icon: icon }, props, { disabled: disabled })),
        icon && (React.createElement(IconLeft, { empty: !props.value, error: error, name: icon, className: "material-icons " + iconCustomClass })),
        loading && React.createElement(InputLoader, { inline: true, animation: "spinner" }),
        !loading &&
            clearButton &&
            onClearClick && React.createElement(ClearButton, { onClick: onClearClick, name: "close" })));
};
Input.defaultProps = {
    type: 'text',
    placeholderPosition: 'left',
    disabled: false,
    required: false,
    autoComplete: 'off',
    error: false,
    loading: false,
    iconCustomClass: '',
};
export default Input;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Input.js.map